import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlPlannerV2FieldworkerMergePickupDropoffLocationInput } from "~/__generated__";

import { PlannerV2FieldworkerMergePickupDropoffLocationDocument } from "../mutations.generated";
import { PlannerV2TravelGroupGetTimelineDocument } from "../queries.generated";

export default function usePlannerV2FieldworkerMergePickupDropoffLocation(onSuccess: (plannerTravelGroupId: string) => void) {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2FieldworkerMergePickupDropoffLocationDocument, {
        refetchQueries: [PlannerV2TravelGroupGetTimelineDocument],
        awaitRefetchQueries: true,
    });

    const mergeFieldworkers = useCallback(
        async (input: GqlPlannerV2FieldworkerMergePickupDropoffLocationInput) => {
            const response = await mutate({
                variables: { input },
            });
            const plannerTravelGroupId = response.data?.plannerV2FieldworkerMergePickupDropoffLocation?.id;
            if (plannerTravelGroupId) onSuccess(plannerTravelGroupId);
        },
        [mutate, onSuccess],
    );

    return {
        mergeFieldworkers,
        loading,
        error,
        data,
    };
}
